module.exports = __webpack_public_path__ + "media/images/emblems/Lignieres-coat_of_arms-195a413e0657e560dac4a0697a719da3.svg";